export default __webpack_public_path__ + "static/media/928.333da8a5.png";